<template>
  <div>
    <v-snackbar v-model="error">
      {{ errorMessage }}
      <v-btn dark color="pink" text @click="error = false"> Close </v-btn>
    </v-snackbar>
    <div id="detail-page">
      <v-container class="content">
        <v-skeleton-loader
          :loading="loading"
          type="card-avatar, article, actions"
        >
          <v-row>
            <v-col cols="12" md="4">
              <v-dialog v-model="dialog" width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-img
                    class="white--text align-end rounded grey lighten-2"
                    :src="loadData.cover"
                    :lazy-src="loadData.cover"
                    v-ripple
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </template>
                <v-card>
                  <v-img
                    class="white--text align-end rounded grey lighten-2"
                    :src="loadData.cover"
                    :lazy-src="loadData.cover"
                    v-ripple
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="8" order-md="first">
              <v-chip filter outlined pill>{{ categoryName }}</v-chip>
              <h2 class="mt-2">{{ loadData.title }}</h2>
              <v-row>
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <div class="mr-2">Oleh {{ loadData.publisher }}</div>
                    <v-avatar
                      color="blue"
                      size="14"
                      class="mr-1"
                      v-if="loadData.publisher_badge == 1"
                    >
                      <v-icon color="white" x-small>done</v-icon>
                    </v-avatar>
                  </div>
                </v-col>
              </v-row>
              <v-divider />
              <v-row class="my-2">
                <v-col cols="12">
                  <div class="d-flex align-start">
                    <v-icon>event</v-icon>
                    <div class="ml-4">
                      Tanggal Acara
                      <strong class="d-block">
                        {{ loadData.string_event_date }}</strong
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex align-start">
                    <v-icon>schedule</v-icon>
                    <div class="ml-4">
                      Waktu Pelaksanaan
                      <strong class="d-block">
                        Jam {{ loadData.starting_time }} -
                        {{ loadData.ending_time }}</strong
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex align-start">
                    <v-icon>place</v-icon>
                    <div class="ml-4">
                      Tempat
                      <strong class="d-block"> {{ loadData.place }}</strong>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" v-if="facultyName">
                  <div class="d-flex align-start">
                    <v-icon>tour</v-icon>
                    <div class="ml-4">
                      Fakultas Terkait
                      <strong class="d-block">
                        {{ _.startCase(_.toLower(facultyName)) }}</strong
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider />
              <!-- Deskripsi  -->
              <v-row v-if="loadData.description">
                <v-col>
                  <h3 class="heading mb-2">Tentang Event</h3>
                  <div v-html="loadData.description" class="body-1"></div>
                  <a
                    v-if="loadData.reference_url"
                    :href="loadData.reference_url"
                    class="text-decoration-none"
                    target="_blank"
                    ><div
                      style=""
                      class="primary lighten-5 rounded-lg pa-3 text--white d-flex justify-space-between"
                    >
                      Lihat tautan referensi
                      <v-icon>chevron_right</v-icon>
                    </div></a
                  >
                </v-col>
              </v-row>
              <v-divider />
              <!-- User have the ticket  -->
              <div v-if="loadData.has_transaction">
                <h3 class="heading my-4">Tiket Kamu</h3>

                <v-card outlined class="mb-3">
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <div>
                          Ticket {{ loadData.has_transaction.ticket_name }}
                        </div>
                        <div class="font-weight-bold orange--text">
                          {{ loadData.has_transaction.price_amount | currency }}
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <div>ID Transaksi</div>
                        <div class="font-weight-bold orange--text">
                          {{ loadData.has_transaction.code }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      :to="/my-ticket/ + loadData.has_transaction.id"
                      text
                      color="primary"
                      block
                      >Lihat Detail</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </div>

              <!-- Event ended  -->
              <div v-else-if="loadData.post_event" class="mt-3">
                <v-alert text color="red" icon="local_activity">
                  Event ini telah berakhir
                </v-alert>
              </div>

              <!-- Eksternal RSVP -->
              <div v-else-if="loadData.is_rsvp == 1">
                <v-btn
                  color="primary"
                  large
                  block
                  link
                  :href="loadData.rsvp_link"
                  target="_blank"
                  >Daftar yuk</v-btn
                >
              </div>

              <!-- Event ticket available  -->
              <div v-else>
                <h3 class="heading my-4">Dapatkan Tiketnya</h3>

                <div v-if="!listTicket.length">
                  <v-alert text color="blue" icon="local_activity">
                    Tidak ada tiket yang di jual
                  </v-alert>
                </div>

                <div v-else>
                  <div v-for="(item, idx) in listTicket" :key="idx">
                    <TicketCard
                      :id="item.id"
                      :ticket-name="item.ticket_name"
                      :price="item.price"
                      :is_certificate="item.is_certificate"
                      :is_snack="item.is_snack"
                      :quota="item.quota"
                      :quota_sold="item.quota_sold"
                      :quota_remain="item.quota_remain"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-skeleton-loader>
        <v-divider />
        <div class="sharenow">
          <h3 class="heading my-4 d-inline-block mr-3">Bagikan</h3>
          <ShareNetwork
            v-for="network in networks"
            :network="network.network"
            :key="network.network"
            :style="{ backgroundColor: network.color }"
            :url="sharing.url + network.utm"
            :title="sharing.title"
            :description="sharing.description"
            :quote="sharing.quote"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser"
          >
            <i :class="network.icon"></i>
            <span>{{ network.name }}</span>
          </ShareNetwork>
        </div>
        <v-divider />
      </v-container>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import TicketCard from '@/components/TicketCard';
import VueSocialSharing from 'vue-social-sharing';

Vue.use(VueSocialSharing);

// use lodash
Vue.use(VueLodash, { lodash: lodash });

export default {
  name: 'EventDetail',
  components: { TicketCard },
  data() {
    return {
      overlay: false,
      dialog: false,
      id: this.$route.params.id,
      requester_user_id: localStorage.getItem('user_id') ?? null,
      loading: true,
      loadData: [],
      error: false,
      errorMessage: null,
      categoryName: '',
      facultyName: '',
      sharing: {
        url: window.location.href,
        title: null,
        description: null,
        quote: 'Semua kebutuhan event kampus',
        hashtags: 'eventversity',
        twitterUser: 'eventversity.id',
      },
      networks: [
        {
          network: 'whatsapp',
          name: 'Whatsapp',
          icon: 'fab fah fa-lg fa-whatsapp',
          color: '#25d366',
          utm:
            '?utm_source=whatsapp&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'facebook',
          name: 'Facebook',
          icon: 'fab fah fa-lg fa-facebook-f',
          color: '#1877f2',
          utm:
            '?utm_source=facebook&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'line',
          name: 'Line',
          icon: 'fab fah fa-lg fa-line',
          color: '#00c300',
          utm:
            '?utm_source=line&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'twitter',
          name: 'Twitter',
          icon: 'fab fah fa-lg fa-twitter',
          color: '#1da1f2',
          utm:
            '?utm_source=twitter&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
        {
          network: 'linkedin',
          name: 'LinkedIn',
          icon: 'fab fah fa-lg fa-linkedin',
          color: '#007bb5',
          utm:
            '?utm_source=linkedin&utm_medium=social_media&utm_campaign=share_social_media&utm_id=share_socmed',
        },
      ],
    };
  },
  mounted() {
    Axios.get(process.env.VUE_APP_API + 'events/' + this.id, {
      params: {
        requestor_id: this.requester_user_id,
      },
    })
      .then((response) => {
        this.loadData = response.data.data;
        this.categoryName = response.data.data.category.name;
        this.facultyName = response.data.data.faculty
          ? response.data.data.faculty
          : null;
        this.sharing.title = this.loadData.title;
        this.sharing.description = this.removeTags(this.loadData.description);
        // Cek status jika tidak verified maka akan di lempar ke 404 page
        if (this.loadData.status_id !== 1) {
          this.$router.push({ name: 'NotFound' });
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.$router.push({ name: 'NotFound' });
        }
        this.error = true;
        this.errorMessage = error;
        console.log(error);
      })
      .finally(() => (this.loading = false));
  },
  computed: {
    listTicket() {
      return Vue._.orderBy(this.loadData.ticket_info, 'price', 'asc');
    },
  },
  methods: {
    removeTags(str) {
      if (str === null || str === '') return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, '');
    },
  },
  metaInfo() {
    return {
      title: this.loadData.title,
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
    };
  },
};
</script>

<style scoped>
#detail-page {
}
.content {
  /*background: #ffffff;*/
}
.label-info {
  font-weight: bolder;
}

.sharenow {
  overflow: auto;
  white-space: nowrap;
  margin-top: 8px;
  margin-bottom: 12px;
}

a[class*='share-network'] {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  display: inline-block;
  margin-right: 8px;
}
</style>
